<h1 mat-dialog-title>Wil je de rit verwijderen?</h1>
<div mat-dialog-content>
  <p class="data-notification">
    Weet je zeker dat je deze rit wilt verwijderen?
    @if (this.data.notification) {
      <p>De personen in de rit zullen op de hoogte worden gesteld.<br /><br /></p>
    }
  </p>
  @if (!this.data.noDeleteReason) {
    <div>
      <p>Geef een reden van verwijderen op.</p>
      <form [formGroup]="deleteForm">
        <mat-radio-group class="delete-reason-radio">
          @for (option of radioOptions; track option) {
            <mat-radio-button
              #radioButton
              [checked]="option === defaultOption"
              (change)="checkState($event)"
              value="{{ option }}"
            >
              {{ option }}
            </mat-radio-button>
          }
        </mat-radio-group>
        <mat-form-field>
          <mat-label>Waarom verwijder je deze rit?</mat-label>
          <textarea formControlName="deleteReason" matInput></textarea>
        </mat-form-field>
      </form>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Nee</button>
  <button
    mat-flat-button
    color="warn"
    [mat-dialog-close]="this.data.noDeleteReason ? true : deleteForm.value.deleteReason"
    [disabled]="deleteForm.invalid"
  >
    Ja
  </button>
</div>
